module.exports = __webpack_public_path__ + "static/media/programma_scratch.3e2abcc6.pdf";